import { AbstractQuery } from 'src/models/query';

export class GetAutomaticUserStatesQuery extends AbstractQuery {
	name = 'IFS_UserState_Query_Queries_GetAutomaticUserStatesQuery';
	parameters = [{}];
}
